/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_R6_NameInputs */

const tr_cerez_s3_r6_name = /** @type {(inputs: Cerez_S3_R6_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sb-<proje>-auth-token`)
};

const en_cerez_s3_r6_name = /** @type {(inputs: Cerez_S3_R6_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sb-<project>-auth-token`)
};

const de_cerez_s3_r6_name = /** @type {(inputs: Cerez_S3_R6_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sb-<Projekt>-auth-token`)
};

const ru_cerez_s3_r6_name = /** @type {(inputs: Cerez_S3_R6_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sb-<проект>-auth-token`)
};

/**
* | output |
* | --- |
* | "sb-<project>-auth-token" |
*
* @param {Cerez_S3_R6_NameInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_r6_name = /** @type {((inputs?: Cerez_S3_R6_NameInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_R6_NameInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_r6_name(inputs)
	if (locale === "de") return de_cerez_s3_r6_name(inputs)
	if (locale === "ru") return ru_cerez_s3_r6_name(inputs)
	return tr_cerez_s3_r6_name(inputs)
});